<template>
  <b-row
    v-if="showHeader"
    class="content-header geopro-page-header"
  >
    <b-col cols="12">
      <div class="geopro-page-header__inner">
        <div class="geopro-page-header__icon">
          <feather-icon
            :icon="pageIcon"
            size="22"
          />
        </div>

        <div class="geopro-page-header__copy">
          <span>{{ moduleLabel }}</span>
          <h1>{{ pageTitle }}</h1>
          <p>{{ pageSubtitle }}</p>
        </div>

        <div
          v-if="$route.meta.breadcrumb"
          class="geopro-page-header__breadcrumb"
        >
          <b-breadcrumb>
            <b-breadcrumb-item to="/">
              <feather-icon
                icon="HomeIcon"
                size="15"
                class="align-text-top"
              />
            </b-breadcrumb-item>
            <b-breadcrumb-item
              v-for="item in $route.meta.breadcrumb"
              :key="item.text"
              :active="item.active"
              :to="item.to"
            >
              {{ item.text }}
            </b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import {
  BBreadcrumb, BBreadcrumbItem, BRow, BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
  },
  computed: {
    showHeader() {
      if (this.$route.meta.hidePageHeader) return false
      return this.$route.meta.breadcrumb || this.$route.meta.pageTitle || this.$route.name
    },
    pageTitle() {
      return this.$route.meta.pageTitle || this.humanize(this.$route.name)
    },
    moduleLabel() {
      const name = String(this.$route.name || '')

      if (name.includes('material-request')) return 'Material Request'
      if (name.includes('purchase-request-direct')) return 'Direct Purchase Request'
      if (name.includes('purchase-request')) return 'Purchase Request'
      if (name.includes('purchase-order')) return 'Purchase Order'
      if (name.includes('payment-request')) return 'Payment Request'
      if (name.includes('transfers')) return 'Transfers'
      if (name.includes('stock-opname')) return 'Stock Opname'
      if (name.includes('assets')) return 'Assets'
      if (name.includes('users')) return 'Users'
      if (name.includes('settings')) return 'Settings'
      if (name.includes('dashboard')) return 'Dashboard'

      return 'GeoProc'
    },
    pageSubtitle() {
      const name = String(this.$route.name || '')

      if (name.includes('confirm')) return 'Review, validate, and approve the requested transaction with clear operational context.'
      if (name.includes('detail') || name.includes('details')) return 'Inspect transaction information, status, documents, and related operational records.'
      if (name.includes('create')) return 'Create a new record with the required information and supporting details.'
      if (name.includes('edit')) return 'Update the selected record while preserving the existing workflow state.'
      if (name.includes('receive')) return 'Track receiving activity, quantities, dates, and warehouse movement.'
      if (name.includes('list')) return 'Browse, filter, and manage records from one clean operational view.'

      return 'Manage procurement activity through a focused, production-ready workspace.'
    },
    pageIcon() {
      const name = String(this.$route.name || '')

      if (name.includes('material-request')) return 'ClipboardIcon'
      if (name.includes('purchase-request')) return 'FileTextIcon'
      if (name.includes('purchase-order')) return 'ShoppingCartIcon'
      if (name.includes('payment-request')) return 'DollarSignIcon'
      if (name.includes('transfers')) return 'RepeatIcon'
      if (name.includes('stock-opname')) return 'ArchiveIcon'
      if (name.includes('assets')) return 'BriefcaseIcon'
      if (name.includes('users')) return 'UsersIcon'
      if (name.includes('settings')) return 'SettingsIcon'
      if (name.includes('dashboard')) return 'ActivityIcon'

      return 'LayersIcon'
    },
  },
  methods: {
    humanize(value) {
      return String(value || 'Page')
        .replace(/^apps-/, '')
        .replace(/-/g, ' ')
        .replace(/\b\w/g, char => char.toUpperCase())
    },
  },
}
</script>
